<template>
  <div
    ref="buttons"
    class="share-buttons"
  >
    <a
      v-if="downloadUrl"
      :href="downloadUrl"
      class="nonst-button"
      target="_blank"
      data-sharedestination="download"
      @click="handleShareClick"
    >
      <span><img
        :src="iconDir + 'download.png'"
        alt="Download"
      ></span>
    </a>
    <a
      v-if="hasNetwork('email')"
      :href="emailLink"
      class="nonst-button"
      data-sharedestination="email"
      @click="handleShareClick"
    >
      <span><img
        :src="iconDir + 'email.png'"
        alt="Email"
      ></span>

    </a>
    <a
      v-if="hasNetwork('sms')"
      :href="smsLink"
      class="nonst-button"
      data-sharedestination="sms"
      @click="handleShareClick"
    >
      <span><img
        :src="iconDir + 'sms.png'"
        alt="Email"
      ></span>

    </a>
    <button
      v-for="network in filteredNetworks"
      :key="network"
      :data-network="network"
      :data-image="image"
      :data-title="title"
      :data-email-subject="title"
      :data-description="description"
      :data-url="shareUrl"
      :data-sharedestination="network"
      class="st-custom-button"
      @click="handleShareClick"
    >
      <span><img
        :src="iconDir + network + '.png'"
        :alt="network"
      ></span>
    </button>
  </div>
</template>

<script>
export default {
    name: 'ShareWidget',
    props: {
        networks: {
            type: Array,
            default: () => ['email', 'sms', 'facebook', 'twitter']
        },
        url: {
            type: [String, Boolean],
            default: false
        },
        downloadUrl: {
            type: [String, Boolean],
            default: false
        },
        image: {
            type: [String, Boolean],
            default: false
        },
        title: {
            type: [String, Boolean],
            default: false
        },
        description: {
            type: [String, Boolean],
            default: false
        }
    },
    data() {
        return {
            shareUrl: false,
            iconDir: process.env.BASE_URL + 'share/',
            isIos: /iPad|iPhone|iPod/.test(navigator.userAgent),
            isAndroid: /Android/i.test(navigator.userAgent)
        }
    },
    computed: {
        hasDownload() {
            return this.networks.indexOf('download') < -1
        },
        mailto() {
            return 'mailto:?subject=body=' + encodeURIComponent(this.title) + "\n\n" + encodeURIComponent(this.url)
        },
        filteredNetworks() {
            return this.networks.filter((item) => item !== 'download' && item !== 'sms' && item !== 'email')
        },
        emailLink() {
            return 'mailto:?to=&subject=' + encodeURIComponent(this.title) + '&body=' + encodeURIComponent(this.url)
        },
        smsLink() {
            return 'sms:' + (this.isIos ? '&' : '?') + 'body=' + encodeURIComponent(this.title) + ' - ' + encodeURIComponent(this.url)
        }
    },
    watch: {
        'url': function (newurl) {
            this.shareUrl = newurl
            window.__sharethis__.load('custom-share-buttons')
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        handleShareClick(event) {
          this.$emit('share', event.currentTarget.getAttribute('data-sharedestination'))
        },
        setShareDetails() {

        },
        init() {
            window.__sharethis__.load('custom-share-buttons')
        },
        hasNetwork(n) {
            return this.networks.indexOf(n) > -1
        }
    }
}
</script>

<style lang="scss" scoped>
.share-buttons {
    display: flex;
    justify-content: space-between;
}
button.st-custom-button, .nonst-button {
    background: white;
    padding: 0;
    border-radius: 0;
    flex: 1;
    text-align: center;
    max-width: 50px;
    max-height: 50px;
    display: flex;
    justify-content: center;
    margin: 0.5rem;
    img {
        max-width: 40px;
        max-height: 40px;
    }
}
</style>